revertChange